import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { formatDate } from './time';
export class AccountantModel {
    id() {
        return this.dto.id;
    }
    companyName() {
        return this.dto.companyName;
    }
    formattedDate() {
        return formatDate(this.dto.date);
    }
    isInvited() {
        return this.dto.status === 'invited';
    }
    isActive() {
        return this.dto.status === 'active';
    }
    invitedEmail() {
        return this.dto.invited.email;
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
